/**
 * ProductZoom Component
 */
(function () {

    'use strict';

    /**
     * ProductZoom Component
     */
    var ProductZoomCmp = {
        bindings: {
            modal: '<',
            productId: '<',
            hasDialog: '<'
        },
        controller: ProductZoomCmpCtrl,
        controllerAs: 'productZoomCtrl',
        templateUrl: 'product-zoom.component.html'
    };

    ProductZoomCmpCtrl.$inject = ['$element', '$scope'];

    function ProductZoomCmpCtrl($element, $scope) {
        var _this = this, pswpHtml = null, zoomFn = $.noop;
        _this.hasNext = false;
        _this.hasPrevious = false;
        _this.images = null;
        _this.thumbnails = null;
        _this.gallery = null;

        //Get PhotoSwipe element on init
        _this.$onInit = function () {
            pswpHtml = $element.find('.pswp')[0];
        };

        _this.goTo = function (index) {
            $scope.$emit('changeSlider',index,_this.gallery.items.length - 1);
            _this.gallery.goTo(index);
        };

        //Subscribe to initialization event
        zoomFn = $scope.$on('itx-product-zoom:initialize', initializeZoom);

        function ItemSlide(mainImage){
            mainImage = removeAkamaiParams(mainImage);
            this.src = mainImage;
            this.w = 0; 
            this.h = 0;
            return this;
        }
        function removeAkamaiParams(url){
            return url.replace(/&impolicy=(.*)&imwidth=(\d*)/,'');
        }
        function _getSmallImage(src) {
            var partials = src.split('_');
            // pathEnd = '_69.jpg?ts=47474747'
            var tempEnd = partials[partials.length-1];
            // cortamos la extension de la imagen ej:'_69'
            var end = tempEnd.slice(tempEnd.indexOf('.jpg'), tempEnd.length);
            // eliminamos el pathEnd del array
            partials.pop();
            // generamos nuestra url modificando solo el tipo de imagen ej: '_13 o _15...' por la _5
            return partials.join('_') + '_5' + end;
        }

        function initializeZoom(event, data) {

            if (_this.productId && _this.productId !== data.productId) {
                return;
            }
            //Prevent executing twice the zoom function
            //In the zoomEnd bind again
            zoomFn();

            _this.gallery = null;

            var items = [];
            _this.thumbnails = [];
            _this.images = data.images;

            if (!data.images) {
                return;
            }

            // hide scroll
            $('html, body').css('overflow-y', 'hidden');

            //Set images and dimensions to 0. Calculated in the gettingData callback
            data.images.forEach(function (image) {
                var img;
                if(image && image.imageUrl){
                    img = image.imageUrl;
                } else {
                    img = image;
                }
                items.push( new ItemSlide(img) );
                _this.thumbnails.push(_getSmallImage(img));
            });
            
            //PhotoSwipe options
            var options = {
                //Start image
                index: data.index || 0,
                showHideOpacity: true,
                history: false,
                bgOpacity: 0,
                loop: false,
                maxSpreadZoom: 2.5,
                spacing: 0,
                clickToCloseNonZoomable: false,
                closeOnScroll: false,
                barsSize: { top: 0, bottom: 0},
                //Necessary for the closing animation
    //             getThumbBoundsFn : function (index) {
    //                 // find thumbnail element
    // var thumbnail = document.querySelectorAll('.my-gallery-thumbnails')[index];

    // // get window scroll Y
    // var pageYScroll = window.pageYOffset || document.documentElement.scrollTop; 
    // // optionally get horizontal scroll

    // // get position of element relative to viewport
    // var rect = thumbnail.getBoundingClientRect(); 

    // // w = width
    // return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
    //             }
            };

            if (_this.modal === false) {
                options.modal = false;
            }
            //Start new PhotoSwipe
            _this.gallery = new PhotoSwipe(pswpHtml, PhotoSwipeUI_Default, items, options); //jshint ignore:line

            _this.gallery.listen('gettingData', function (index, item) {
                //Recalculate dimensions with downloaded images
                if (item.w < 1 || item.h < 1) { // unknown size
                    var img = new Image();
                    // calculate container ratio:
                    var containerRatio = _this.gallery.viewportSize.x / _this.gallery.viewportSize.y;
                    img.onload = function () { // will get size after load
                        // calculate image ratio:
                        var ratio = this.width / this.height;
                        if (containerRatio > ratio) { // fill width
                            item.w = _this.gallery.viewportSize.x;
                            item.h = item.w / ratio;
                        } else { // fill height
                            item.h = _this.gallery.viewportSize.y;
                            item.w = item.h * ratio;
                        }
                        _this.gallery.invalidateCurrItems(); // reinit Items
                        _this.gallery.updateSize(true); // reinit Items
                    };
                    
                    img.src = item.src; // let's download image
                }
            });

            _this.gallery.listen('initialZoomInEnd', function () {
                $('.pswp__container').on('tap', function () {
                    _this.gallery.close();
                });

                var $window = $(window);
                $('.pswp__container').on('mousemove', function (event) {
                    if (_this.gallery.getZoomLevel() === 1) {
                        var height = $window.height();
                        var width = $window.width();
                        var item = _this.gallery.currItem;

                        var posX = event.clientX / width;
                        var posY = event.clientY / height;
                        var panX = item.bounds.max.x * posX;
                        var panY = item.bounds.max.y * posY;
                        _this.gallery.applyZoomPan(_this.gallery.getZoomLevel(), panX, panY);
                    }
                });

                zoomFn = $scope.$on('itx-product-zoom:initialize', initializeZoom);
            });

            _this.gallery.listen('afterChange', function() {
                _this.hasPrevious = _this.gallery.getCurrentIndex() > 0;
                _this.hasNext = _this.gallery.getCurrentIndex() < (_this.gallery.items.length - 1);
                if ($scope.$root.$$phase !== '$apply' &&
                    $scope.$root.$$phase !== '$digest') {
                    $scope.$digest();
                }
            });

            _this.gallery.listen('destroy', function() {
                // restore scroll
                $('html, body').css('overflow-y', '');
            });

            //Close gallery on resize
            $(window).on('debouncedresize', function () {
                _this.gallery.close();
            });

            //Initialize gallery
            _this.gallery.init();
        }
    }

    /** Public */
    angular.module('itxApp.common')
        .component('productZoom', ProductZoomCmp);

})();
